/**
 * @file 全角→半角変換
 *
 */
'use strict';

/**
 * @classname ZenkakuToHankaku
 * @classdesc 全角→半角変換
 */
export default class ZenkakuToHankaku {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('ZenkakuToHankaku.constructor');
		this._$e = $e;
		this._$e.on('blur', () => this.onBlur());
	};

	/**
	 * blurのコールバック
	 *
	 * @memberof ZenkakuToHankaku
	 * @return {undefined}
	 */
	onBlur() {
		console.log('ZenkakuToHankaku.onBlur');
		let str = this._$e.val();
		str = str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
			return String.fromCharCode(s.charCodeAt(0) - 65248);
		});
		str = str.replace(/ー/g, '-'); // 全角ハイフン
		str = str.replace(/ー/g, '-'); // ひらがな
		str = str.replace(/ー/g, '-'); // カタカナ
		str = str.replace(/＿/g, '_'); // アンダースコア
		str = str.replace(/＠/g, '@'); // アットマーク
		str = str.replace(/．/g, '.'); // 全角ピリオド
		str = str.replace(/＋/g, '+'); // 全角プラス
		str = str.replace(/＝/g, '='); // 全角イコール
		this._$e.val(str);
	}
}
